<template>
    <label class="form-switch" tabindex="0" @keydown.enter.prevent="updateInput" @keydown.space.prevent="updateInput">
        <input
            type="checkbox"
            :disabled="disabled"
            :checked="isChecked"
            :value="value"
            @change="updateInput"
        >
        <i></i>
        <span class="form-switch-label" v-show="label">
            {{ label }}
        </span>
    </label>
</template>

<script>
    export default {
        model: {
            prop: 'modelValue',
            event: 'change'
        },
        props: {
            value: {
                type: Boolean,
                required: true,
            },
            modelValue: {
                default: '',
            },
            label: {
                type: String,
                defaultValue: '',
            },
            disabled: {
                type: Boolean,
                defaultValue: false,
            },
            trueValue: {
                default: true,
            },
            falseValue: {
                default: false,
            },
        },
        computed: {
            isChecked() {
                if (this.modelValue instanceof Array) {
                    return this.modelValue.includes(this.value)
                }

                return this.modelValue === this.trueValue;
            },
        },
        methods: {
            updateInput(event) {
                let isChecked;
                if (event.target.tagName === 'INPUT') {
                    isChecked = event.target.checked;
                } else {
                    isChecked = !this.isChecked;
                }

                if (this.modelValue instanceof Array) {
                    let newValue = [...this.modelValue];

                    if (isChecked) {
                        newValue.push(this.value);
                    } else {
                        newValue.splice(newValue.indexOf(this.value), 1);
                    }

                    this.$emit('change', newValue);
                } else {
                    this.$emit('change', isChecked ? this.trueValue : this.falseValue);
                }
            },
        },
    }
</script>

<style lang="css">
.form-switch {
    display: inline-flex;
    align-items: center;
    cursor: pointer;
    -webkit-tap-highlight-color: transparent;
}

.form-switch i {
    position: relative;
    display: inline-block;
    margin-right: .5rem;
    width: 46px;
    min-width: 46px;
    height: 26px;
    background-color: #e6e6e6;
    border-radius: 23px;
    vertical-align: text-bottom;
    transition: all 0.3s linear;
}

.form-switch i::before {
    content: "";
    position: absolute;
    left: 0;
    width: 42px;
    height: 22px;
    background-color: #e6e6e6;
    border-radius: 11px;
    transform: translate3d(2px, 2px, 0) scale3d(1, 1, 1);
    transition: all 0.25s linear;
}

.form-switch i::after {
    content: "";
    position: absolute;
    left: 0;
    width: 22px;
    height: 22px;
    background-color: #042748;
    border-radius: 11px;
    box-shadow: 0 2px 2px rgba(0, 0, 0, 0.24);
    transform: translate3d(2px, 2px, 0);
    transition: all 0.2s ease-in-out;
}

.form-switch:active i::after {
    width: 28px;
    transform: translate3d(2px, 2px, 0);
}

.form-switch:active input:checked + i::after {
    transform: translate3d(16px, 2px, 0);
}

.form-switch input {
    display: none;
}

.form-switch input:checked + i {
    background-color: #ABEA47;
}

.form-switch input:checked + i::before {
    transform: translate3d(18px, 2px, 0) scale3d(0, 0, 0);
}

.form-switch input:checked + i::after {
    transform: translate3d(22px, 2px, 0);
}

.form-switch-label {
    margin-left: 15px;
    margin-bottom: 0 !important;
    color: #000;
    font-size: 16px;
}

@media (max-width: 767px) {
    .form-switch-label {
        font-size: 14px;
    }
}
</style>
